var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-wrap"},[_c('div',{staticClass:"front-wrap"},[_c('router-view'),(_vm.isLockingUi)?_c('div',{attrs:{"id":"fullOverlay"}},[_c('div',{staticClass:"text"},[_c('b-spinner'),_vm._v(" 処理中です… ")],1)]):_vm._e()],1),_c('AppErrorWatchDialog'),_c('SessionCheckerComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }